import { makeVar } from '@apollo/client';

/**
 * Reactive var indicating whether the user's session has expired and they need to re-authenticate.
 * Set from the Apollo error link only on a genuine HTTP 401 (expired/rejected token), and reset
 * on any successful response so a transient blip can't latch it. Subscribed via useReactiveVar()
 * in SessionExpiredDialog.
 */
export const sessionExpiredVar = makeVar<boolean>(false);
